
import { fetchMergedProvinces } from "api/interna-api";
import LocationSelectModal from "components/molecules/LocationSelectModal";
import ModalsCompare from "components/molecules/ModalsCompare";
import ViewedProduct from "components/molecules/ViewedProduct";
import Modal from "components/organisms/Modal";
import { INTERNAL } from "constants/env";
import { VALUE_INTERNAL } from "constants/global";
import {
  getDefaultLocationDeliveryStore,
  setDefaultLocationDeliveryStore
} from "constants/location";
import { zIndex } from "constants/zIndexs";
import { useSelector } from "hooks/useApp";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchCitiesOnSuccess } from "redux/actions/general/cities";
import { requestFetchSystem } from "redux/actions/general/system";
import { saveLocationBuying } from "redux/actions/location/locationBuying";
import { setModal } from "redux/reducers/view/modal";
import ModalBody from "components/organisms/Modal/Body";
import ModalHeader from "components/organisms/Modal/Header";
import Text from "components/atoms/Text";

const FixedComponents: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const [showLocationSelectModal, setShowLocationSelectModal] = useState(false);
  const [listCities, setListCities] = useState([]);
  const { cities } = useSelector(state => state.general);
  const { modal } = useSelector(state => state.view);
  const userData = useSelector(state => state?.userInfor);
  const {
    //  loading: loadingToAddToCart,
    code,
    // error,
  } = useSelector(
    state => state.products.cart,
  );

  const isValidUser = useMemo(() => {
    if (INTERNAL !== VALUE_INTERNAL) { return true }
    return !!userData && !!userData?.active
  }, [userData])

  useEffect(() => {
    if (!isValidUser) { return };

    // Fetching System
    dispatch(requestFetchSystem());

    (async () => {
      try {
        // Fetching Cities
        const city = await fetchMergedProvinces();
        dispatch(fetchCitiesOnSuccess(city));

        // Init Location Buying
        let defaultLocationLocal = getDefaultLocationDeliveryStore();

        const existLocation = city?.find(
          (item: any) => item?.id === defaultLocationLocal?.id,
        );

        if (!defaultLocationLocal || !existLocation) {
          dispatch(setModal("stock", true));
        } else {
          dispatch(saveLocationBuying(defaultLocationLocal));
        }
      } catch (error) {
        console.error('Error fetching cities: ', error);
        dispatch(fetchCitiesOnSuccess([]));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isValidUser]);

  useEffect(() => {
    if (!isValidUser) { return };
    setShowLocationSelectModal(modal["stock"]);
  }, [modal, isValidUser]);

  const { locationBuying } = useSelector(state => state);
  const [
    currentSelectedDeliveryItemIndex,
    setCurrentSelectedDeliveryItemIndex,
  ] = useState<number>(-1);

  useEffect(() => {
    if (!isValidUser) { return };
    if (cities && cities?.data?.length > 0) {
      setListCities(
        cities.data.map((city: any) => ({
          name: city.name,
          id: city.id,
        })),
      );
    }
  }, [cities, isValidUser]);

  useEffect(() => {
    if (!isValidUser) { return };
    if (locationBuying && listCities && !!listCities?.length) {
      const fIndex = listCities.findIndex(
        item => item.name === locationBuying.name,
      );
      setCurrentSelectedDeliveryItemIndex(fIndex > -1 ? fIndex : 0);
    }
  }, [listCities, locationBuying, isValidUser]);

  const isShowError600 = useMemo(() => code && Array.isArray(code) && code?.length > 0 && code.includes('600'), [code]);

  return (
    <>
      {showLocationSelectModal && (
        <LocationSelectModal
          currentIndex={currentSelectedDeliveryItemIndex}
          show={showLocationSelectModal}
          list={listCities}
          onSelectedValue={(item: any) => {
            setDefaultLocationDeliveryStore(item);
            setShowLocationSelectModal(false);
            dispatch(saveLocationBuying(item));
            dispatch(setModal("stock", false));
            toast.info("Tỉnh thành đã được lưu");
          }}
        />
      )}
      <ToastContainer
        autoClose={3500}
        hideProgressBar
        closeOnClick
        pauseOnHover
        style={{ zIndex: zIndex.toast }}
      />

      <ViewedProduct />
      <ModalsCompare />

      {
        isShowError600 && (
          <Modal
            isOpen
            onCloseRequest={() => {
              dispatch({ type: "RESET_ERROR_CART" });
            }}
          >
            <ModalHeader
              onCloseRequest={() => {
                dispatch({ type: "RESET_ERROR_CART" });
              }}
            />
            <ModalBody>
              <Text modifiers={["center"]}>
                Không thể mua sản phẩm có áp dụng khuyến mãi
                cùng lúc với sản phẩm đã được áp dụng
                chương trình thu cũ đổi mới.
              </Text>
            </ModalBody>
          </Modal>
        )
      }
    </>
  );
};

export default FixedComponents;
